import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Cuál es la diferencia entre SAINT® y la TMS convencional?",
    answer:
      "SAINT® combina orientación individualizada por fMRI, estimulación theta burst y un calendario acelerado de 50 sesiones durante cinco días. La TMS convencional utiliza un punto de estimulación estándar y suele durar seis semanas.",
  },
  {
    question: "¿SAINT® es mejor que la TMS convencional?",
    answer:
      "No hay una respuesta universal. SAINT® y la TMS convencional son enfoques distintos. La idoneidad depende del diagnóstico, el historial de tratamiento y otros factores. Una evaluación psiquiátrica es el primer paso.",
  },
];

export const esSaintVsTraditional = makeEsArticle({
  slug: "saint-vs-traditional-tms",
  title: "SAINT® vs TMS convencional",
  description:
    "SAINT® frente a la TMS convencional: orientación por fMRI, estimulación theta burst, calendario de cinco días frente a seis semanas. La idoneidad se confirma mediante una evaluación psiquiátrica.",
  h1: "SAINT® vs TMS convencional",
  breadcrumbLabel: "SAINT® vs TMS convencional",
  shortAnswer:
    "SAINT® combina orientación individualizada por fMRI, estimulación theta burst y un calendario acelerado de 50 sesiones durante cinco días. La TMS convencional utiliza un punto de estimulación estándar y suele durar seis semanas. Ambos están autorizados por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. La idoneidad se confirma mediante una evaluación psiquiátrica.",
  keyTakeaways: [
    "SAINT® combina orientación por fMRI y estimulación theta burst.",
    "SAINT® se administra durante cinco días.",
    "La TMS convencional utiliza un punto de estimulación estándar.",
    "La TMS convencional suele durar seis semanas.",
    "Ambos están autorizados por la FDA para el trastorno depresivo mayor.",
  ],
  sections: [
    {
      heading: "Orientación",
      paragraphs: [
        "SAINT® utiliza orientación individualizada por fMRI para localizar el circuito cerebral de cada persona. La TMS convencional utiliza un punto de estimulación estándar basado en medidas anatómicas generales.",
      ],
    },
    {
      heading: "Estimulación y calendario",
      paragraphs: [
        "SAINT® utiliza estimulación theta burst y administra 50 sesiones durante cinco días. La TMS convencional utiliza estimulación continua y suele durar seis semanas, con sesiones diarias de lunes a viernes.",
      ],
    },
    {
      heading: "Cobertura del seguro",
      paragraphs: [
        "La TMS convencional está ampliamente cubierta por los seguros para el trastorno depresivo mayor. SAINT® suele ser de pago directo. [[Verificamos los beneficios|/es/saint-tms-insurance-coverage]] de cada paciente sin costo. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
